import React, { FC } from "react";
import { Button } from "@xapp/components";
import { List, ListItem } from "react-toolbox/lib/list";

import { OrgIcon } from "components/OrgIcon";

import style from "./style.scss";
import { Organization } from "generated/graphql";

export interface OrganizationListMenuProps {
    readonly organizations: readonly Pick<Organization, "organizationId" | "name">[];
    onNavClick(path: string): void;
}

const OrganizationsListMenu: FC<OrganizationListMenuProps> = (props: OrganizationListMenuProps) => {
    const { organizations } = props;

    return (
        <div className={style.myOrganizations}>
            <h5>My Organizations</h5>

            <List>
                {organizations.map((org: Pick<Organization, "organizationId" | "name">, i: number) => {
                    const orgPath = `/${org.organizationId}`;
                    const orgIcon = <OrgIcon organization={org} />;

                    return (
                        <ListItem
                            leftIcon={orgIcon}
                            caption={org.name}
                            key={i}
                            onClick={props.onNavClick.bind(undefined, orgPath)}
                            selectable
                        />
                    );
                })}
            </List>

            <footer>
                <Button variation="flat" label="View All" onClick={props.onNavClick.bind(undefined, "/list")} />
            </footer>
        </div>
    );
};

export { OrganizationsListMenu as UserMenu };
